/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Grid,
  makeStyles,
} from "@material-ui/core";

import componentStyles from "assets/theme/views/admin/dashboard";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";

import useLogs from "hooks/logs";
import { useWebsocketFetch } from "hooks/useWebsocketFetch";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { useVisionLogin } from "hooks/useVisionLogin";
import HeaderClientes from "components/_refactor/headers/clients";
import ClearButton from "components/_refactor/button/clear";
import LoadingData from "components/Loading/LoadingData";
import StructureFields from "components/_refactor/fields/structure";
import TabelaMonitorSeniorSeta from "./table/TableMonitorSeniorSeta";
import { API_ENV } from "constants/environment";
import FromToDateField from "components/_refactor/fields/from-to-date";
import InputText from "components/_refactor/text/input";
import { IsMobile, IsMobile900 } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);

const handleClearFinalDate = () => {
  document.getElementById("#buttonClearFinalDate").click();
};

const handleClearInitialDate = () => {
  document.getElementById("#buttonClearInitialDate").click();
};

export function DashboardMonitorSenior() {
  const { userId } = useVisionLogin();
  const { setLocalStorageActions } = useLogs();
  const snackbar = useSnackbar();
  const classes = { ...useStyles(), ...useStylesCardDeck() };

  const { data, handleFetchData, status, handleFetchUrl } = useWebsocketFetch({
    onSuccess: handleGetTableData,
  });

  const [searching, setSearching] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [idPedido, setIdPedido] = useState("");
  const [structureFilters, setStructureFilters] = useState({});
  const [structureLoading, setStructureLoading] = useState([]);
  const [previousData, setPreviousData] = useState(null);
  const [numeroNf, setNumeroNf] = useState("");
  const [observation, setObservation] = useState("");

  const [dataLimite, setDataLimite] = useState("");
  const [dataInicial, setDataInicial] = useState("");
  const [dataFinal, setDataFinal] = useState("");

  const [errorMessage, setErrorMessage] = useState(null);
  const [dataTable, setDataTable] = useState(null);
  const [clearFilters, setClearFilters] = useState(false);
  const [lastSearchParams, setLastSearchParams] = useState(null);
  const intervalRef = useRef(null);

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  useEffect(() => {
    if (dataInicial !== "") {
      const selectedInitialDate = new Date(dataInicial);
      const data31dias = new Date(
        selectedInitialDate?.setDate(selectedInitialDate?.getDate() + 30)
      )
        .toISOString()
        .slice(0, 10);

      setDataLimite(data31dias);
    }
  }, [dataInicial]);

  const savingData = (tableData) => {
    if (tableData?.length < 1) {
      setDataTable([]);
    } else {
      setDataTable(data);
    }
  };

  function handleGetTableData() {
    setSearching(false);
    if (JSON.stringify(data)) {
      savingData(data);
      setPreviousData(data);
    }
  }

  const handleSearch = async () => {
    setDataTable(null);
    setLastSearchParams(null);
    setSearching(true);
    setCancelLoading(false);
    setErrorMessage(null);

    setLocalStorageActions({
      nomeTela: "Monitor Senior Sata",
      idMenu: "180",
      acao: "Acessou a tela Monitor Senior Seta",
    });
    let initial;
    let final;

    if (dataInicial === "") {
      const today = new Date().toISOString().slice(0, 10);
      const selectedInitialDate = new Date(today);
      const dateLassYear = new Date(
        selectedInitialDate?.setDate(selectedInitialDate?.getDate() - 365)
      )
        .toISOString()
        .slice(0, 10);

      initial = dateLassYear;
      final = today;
    } else {
      if (dataFinal === "") {
        const selectedInitialDate = new Date(dataInicial);
        selectedInitialDate.setDate(selectedInitialDate.getDate() + 30);

        const CreateFinalDate = selectedInitialDate.toISOString().slice(0, 10);

        final = CreateFinalDate;
        initial = dataInicial;
      } else {
        final = dataFinal;
        initial = dataInicial;
      }
    }

    setLastSearchParams({
      dtIni: initial,
      dtFim: final,
      idPessoaLoja: structureFilters?.idLoja ? structureFilters?.idLoja : "",
      idPedido: idPedido ? idPedido : "",
      numeroNf: numeroNf || "",
      observacao: observation || "",
    });
  };

  const handleSendMessage = (message) => {
    handleFetchData(message);
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setIdPedido("");

    handleClearInitialDate();
    handleClearFinalDate();
    setDataLimite("");
    setDataInicial("");
    setDataFinal("");
    setNumeroNf("");
    setObservation("");

    setTimeout(() => {
      setClearFilters(false);
    }, 1000);
  };

  const handleStopSearching = () => {
    handleFetchUrl("");
    setCancelLoading(true);
    setSearching(false);
    setDataTable(null);
    handleFetchUrl(
      `wss://bm6fkt7kwa.execute-api.us-east-1.amazonaws.com/${API_ENV}`
    );
  };

  useEffect(() => {
    if (
      status === "empty" &&
      !cancelLoading &&
      !searching &&
      dataTable?.length === 0
    ) {
      snackbar.showMessage("Sua busca não retornou nenhum resultado.", {
        severity: "success",
      });
    } else if (
      status === "empty" &&
      !cancelLoading &&
      searching &&
      dataTable === null
    ) {
      setSearching(false);
      snackbar.showMessage("Sua busca não retornou nenhum resultado.", {
        severity: "success",
      });
    }
  }, [status, cancelLoading, searching, dataTable]);

  useEffect(() => {
    if (lastSearchParams && userId) {
      handleSendMessage({
        action: "monitor-senior-seta",
        params: {
          querystring: lastSearchParams,
          header: {
            "K-IdUser": userId,
          },
        },
      });
    }
  }, [lastSearchParams, userId]);

  useEffect(() => {
    if (!clearFilters) {
      handleSearch();
    }
  }, [clearFilters]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      handleSearch();
    }, 180000);

    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (structureFilters?.idLoja === "") {
      setClearFilters(false);
    }
  }, [structureFilters]);

  useEffect(() => {
    if (cancelLoading && dataTable === null && lastSearchParams === null) {
      handleFetchUrl(
        `wss://bm6fkt7kwa.execute-api.us-east-1.amazonaws.com/${API_ENV}`
      );
    }
  }, [cancelLoading, dataTable, lastSearchParams]);

  useEffect(() => {
    if (errorMessage && !cancelLoading) {
      snackbar.showMessage(errorMessage, { severity: "error" });
    }
  }, [cancelLoading, errorMessage]);

  useEffect(() => {
    handleFetchUrl(
      `wss://bm6fkt7kwa.execute-api.us-east-1.amazonaws.com/${API_ENV}`
    );
  }, []);

  return (
    <>
      <HeaderClientes
        section="Monitor Integração Seta x Senior"
        subsection="Dashboard"
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Filtros"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>

              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <StructureFields
                    clearFilters={clearFilters}
                    onStructureFieldsChange={setStructureFilters}
                    disableAll={searching}
                    onStructureFieldsLoad={setStructureLoading}
                    hideFields={[
                      "channel",
                      "brand",
                      "representative",
                      "economicGroup",
                    ]}
                    ownStore
                  />
                </Grid>
                <Grid item xs={12}>
                  <Divider style={{ margin: "0.5rem 0" }} />
                </Grid>
                <Grid container spacing={2} alignItems="center">
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    style={{ marbinBottom: "1.5rem" }}
                  >
                    <InputText
                      label="Número do Pedido"
                      value={idPedido}
                      onChange={(e) => {
                        setIdPedido(e.target.value.slice(0, 20));
                      }}
                      disabled={searching || clearFilters}
                      placeholder="Digite o número do pedido"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    style={{ marbinBottom: "1.5rem" }}
                  >
                    <InputText
                      label="Número da NF"
                      value={numeroNf}
                      onChange={(e) => {
                        setNumeroNf(e.target.value.slice(0, 20));
                      }}
                      disabled={searching || clearFilters}
                      placeholder="Digite o número da NF"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    style={{ marbinBottom: "1.5rem" }}
                  >
                    <InputText
                      label="Observação"
                      value={observation}
                      onChange={(e) => {
                        setObservation(e.target.value);
                      }}
                      disabled={searching || clearFilters}
                      placeholder="Digite uma observação"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FromToDateField
                      label={"Período"}
                      initialDate={dataInicial}
                      finalDate={dataFinal}
                      setInitialDate={setDataInicial}
                      setFinalDate={setDataFinal}
                      disabled={searching || clearFilters}
                      isMobile={isMobile900}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      color="default"
                      variant="contained"
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      onClick={handleSearch}
                      disabled={searching || clearFilters}
                    >
                      {searching ? "Pesquisando..." : "Pesquisar"}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ClearButton
                      disable={searching}
                      onClick={() => handleClearFilters()}
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <LoadingData
              searching={searching}
              onClick={() => handleStopSearching()}
              classes={classes.root}
              label="Buscando dados..."
            />
          </Grid>
          {!cancelLoading && !searching && (
            <Grid item xs={12}>
              <TabelaMonitorSeniorSeta dataTable={dataTable} />
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
}
